import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { Zap, Calendar, Trophy, Dumbbell, Activity, ArrowRight } from 'lucide-react'

const products = [
  {
    id: 'aicoach',
    name: 'Lafit智拍AI网球教练',
    tagline: 'AI 动作分析 · 职业动作对比',
    desc: '场馆多摄像头自动录制，AI 对比职业球员动作生成左右分屏对比视频和多维度分析报告。',
    icon: Zap,
    color: '#3b82f6',
    href: '/aicoach',
  },
  {
    id: 'venues',
    name: 'Lafit运动订场',
    tagline: '一键预约 · 轻松订场',
    desc: '覆盖多场馆的在线预订系统，支持场地查询、时段预约、在线支付。',
    icon: Calendar,
    color: '#10b981',
    href: '/venues',
  },
  {
    id: 'ladder',
    name: 'Lafit网球挑战榜',
    tagline: '挑战赛排行 · 积分竞技',
    desc: '网球挑战升降级系统，支持单打/双打挑战、实时积分排名。',
    icon: Trophy,
    color: '#f59e0b',
    href: '/ladder',
  },
  {
    id: 'gym',
    name: 'Lafit连锁智能健身房',
    tagline: '智能健身 · 无人值守',
    desc: '采用人脸识别门禁、智能跑步机，实现 24 小时无人值守健身房。',
    icon: Dumbbell,
    color: '#ec4899',
    href: 'https://gzzh.lafit.club',
    external: true,
  },
  {
    id: 'treadmill',
    name: 'Lafit智能跑步机',
    tagline: 'AI 陪跑 · 数据追踪',
    desc: '搭载 AI 教练系统的智能跑步机，实时监测运动数据。',
    icon: Activity,
    color: '#8b5cf6',
    href: 'https://sh.lafit.club',
    external: true,
  },
]

export default function Home() {
  return (
    <div className="min-h-screen pt-16">
      {/* Hero */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-20" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[600px] opacity-15"
          style={{ background: 'radial-gradient(ellipse, rgba(255,255,255,0.1), transparent 70%)', filter: 'blur(80px)' }} />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-medium mb-6"
              style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.15)', color: '#94a3b8' }}>
              <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
              Lafit Technology
            </div>

            <h1 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight">
              运动科技
              <br />
              <span className="gradient-text">智享未来</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              专注运动数字化，AI + 智能硬件赋能体育产业
            </p>
          </motion.div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            {products.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                {product.external ? (
                  <a
                    href={product.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group block h-full rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1"
                    style={{
                      background: 'linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01))',
                      border: `1px solid ${product.color}22`,
                    }}
                    onMouseEnter={e => (e.currentTarget as HTMLElement).style.boxShadow = `0 0 40px ${product.color}15`}
                    onMouseLeave={e => (e.currentTarget as HTMLElement).style.boxShadow = 'none'}
                  >
                    <div className="p-5">
                      <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                        style={{ background: `${product.color}15`, color: product.color }}>
                        <product.icon className="w-6 h-6" />
                      </div>
                      <h3 className="text-base font-bold text-white mb-1">{product.name}</h3>
                      <p className="text-xs font-medium mb-2" style={{ color: product.color }}>{product.tagline}</p>
                      <p className="text-xs text-gray-500 line-clamp-2">{product.desc}</p>
                      <div className="mt-4 flex items-center gap-1 text-xs font-medium transition-all group-hover:gap-2"
                        style={{ color: product.color }}>
                        了解更多
                        <ArrowRight className="w-3 h-3" />
                      </div>
                    </div>
                  </a>
                ) : (
                  <Link
                    to={product.href}
                    className="group block h-full rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1"
                    style={{
                      background: 'linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01))',
                      border: `1px solid ${product.color}22`,
                    }}
                    onMouseEnter={e => (e.currentTarget as HTMLElement).style.boxShadow = `0 0 40px ${product.color}15`}
                    onMouseLeave={e => (e.currentTarget as HTMLElement).style.boxShadow = 'none'}
                  >
                    <div className="p-5">
                      <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                        style={{ background: `${product.color}15`, color: product.color }}>
                        <product.icon className="w-6 h-6" />
                      </div>
                      <h3 className="text-base font-bold text-white mb-1">{product.name}</h3>
                      <p className="text-xs font-medium mb-2" style={{ color: product.color }}>{product.tagline}</p>
                      <p className="text-xs text-gray-500 line-clamp-2">{product.desc}</p>
                      <div className="mt-4 flex items-center gap-1 text-xs font-medium transition-all group-hover:gap-2"
                        style={{ color: product.color }}>
                        了解更多
                        <ArrowRight className="w-3 h-3" />
                      </div>
                    </div>
                  </Link>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-10" />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
              联系我们
            </h2>
            <p className="text-gray-400 mb-6">
              期待与您的合作
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm">
              <a href="tel:4008365001" className="text-gray-300 hover:text-white transition-colors">
                电话：400-8365-001
              </a>
              <span className="text-gray-600">·</span>
              <a href="mailto:info@lafit.club" className="text-gray-300 hover:text-white transition-colors">
                邮箱：info@lafit.club
              </a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}
